<template>
	<section class="SubmitAvailabilityPage">
		<header class="Header">
			<Button class="header-buttons Button" @click="$router.back()">
				<ArrowLeftIcon size="24"/>
			</Button>
			<a class="Header-logo" href="/">
				<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			</a>
			<span v-if="isLoading"
				  style="color: #777; font-size: 13px; position: absolute; display: flex; justify-content: center; align-items: center; left: 50%; top: 5px; margin-left: -15px; background: #fff; box-shadow: 0 2px 5px rgba(0,0,0,0.5); border-radius: 9999px; width: 30px; height: 30px;">
				<LoadingIndicator style="height: 16px;"/>
			</span>
		</header>
		<main>
			<div class="selection-section" v-if="selection === 'main'">
				<Button class="selection-item" v-if="allowedTo('doorgeven/uren')" @click="$router.push({name: 'doorgevenUren'})">URENREGISTRATIE</Button>
				<Button class="selection-item" v-if="allowedTo('doorgeven/ziekte')" @click="selection='ziekte'">ZIEKTE</Button>
				<Button class="selection-item" v-if="allowedTo('doorgeven/verlof')" @click="selection='verlof'">VERLOF</Button>
			</div>
			<SubmitAvailabilityZiekte v-if="selection === 'ziekte'" :team-leader="teamLeader" :office-employees="officeEmployees"></SubmitAvailabilityZiekte>
			<SubmitAvailabilityVerlof v-if="selection === 'verlof'"></SubmitAvailabilityVerlof>
			<Button v-if="selection === 'main'" class="cancel" @click="$router.back()">ANNULEER</Button>
		</main>
	</section>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {client} from "../store";
import Button from "../components/Button.vue";
import SubmitAvailabilityZiekte from "../components/SubmitAvailability/Ziekte.vue";
import SubmitAvailabilityVerlof from "../components/SubmitAvailability/Verlof.vue";
import {ArrowLeftIcon} from 'vue-feather-icons';
import LoadingIndicator from "../components/LoadingIndicator.vue";

export default {
	components: {
		LoadingIndicator,
		SubmitAvailabilityVerlof,
		SubmitAvailabilityZiekte,
		Button,
		ArrowLeftIcon
	},

	data() {
		return {
			selection: 'main',
			teamLeader: null,
			officeEmployees: null
		}
	},

	computed: {
		...mapState({
			isLoading: "loading"
		}),
		...mapState('auth', {
			viewer: 'viewer',
		}),
		...mapGetters({
			allowedTo: 'auth/allowedTo',
		})
	},

	beforeMount() {
		this.getTeamLeader();
		this.getOfficeEmployees();
	},

	methods: {
		getTeamLeader() {
			client.query(`
				query($userId: ID, $employeeStatus: String) {
					getUsersByEmployeeStatusForUserId(userId: $userId, employeeStatus: $employeeStatus) {
						phone,
						display_name
					}
				}
			`, {
				userId: this.viewer.id,
				employeeStatus: "Teamleider"
			}).then((result) => {
				this.teamLeader = result.getUsersByEmployeeStatusForUserId[0];
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: 'app',
					title: 'Fout ophalen teamleider',
					type: 'error',
					text: `Teamleider kon niet opgehaald worden`,
				});
			});
		},

		getOfficeEmployees() {
			client.query(`
				query($userId: ID, $employeeStatus: String) {
					getUsersByEmployeeStatusForUserId(userId: $userId, employeeStatus: $employeeStatus) {
						phone,
						display_name
					}
				}
			`, {
				userId: this.viewer.id,
				employeeStatus: "Kantoor"
			}).then((result) => {
				this.officeEmployees = result.getUsersByEmployeeStatusForUserId;
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Fout ophalen kantoor medewerkers",
					type: "error",
					text: "Teamleider kon niet opgehaald worden",
				});
			});
		}
	}
}
</script>

<style lang="scss" scoped>
main {
	height: calc(100% - 46px);
}

.SubmitAvailabilityPage {
	height: 100%;
}

.Header {
	box-shadow: none;
	border-bottom: 2px solid #eee;
	display: grid;
	grid-template-columns: 1fr auto 1fr;
}

.header-buttons {
	box-shadow: none;
	padding: 8px;
	max-width: 64px;
}

.Header-logo {
	margin-left: 0;
	display: flex;
	height: 100%;
	width: 200px;
	align-items: center;
	justify-content: center;
}

.selection-section {
	padding: 16px;
	border-bottom: 2px solid #eee;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.selection-item {
	font-weight: 800;
	width: 100%;
	background-color: #1aae9f;
	color: #FFFFFF;
	text-align: center;
	border-radius: 4px;
}

Button.cancel {
	font-weight: bold;
	color: #FFFFFF;
	background-color: #d3455b;
	border-radius: 4px;
	margin: 16px;
	text-align: center;
	width: calc(100% - 32px);
}
</style>
